export type FilterCriteriaType = 'include' | 'startsWith' | 'array-includes';
export class FilterCriteria {
  key: string;
  value: any;
  type: FilterCriteriaType;

  constructor(key: string, value: any, type: FilterCriteriaType) {
    this.key = key;
    this.value = value;
    this.type = type;
  }
}
